import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Event bus for logout events.
 *
 * Allows decoupling of auth module from feature modules.
 * Features subscribe to logout events and clear their caches independently.
 */
@Injectable({ providedIn: 'root' })
export class LogoutEventBus {
  private readonly _logoutSubject = new Subject<void>();

  /**
   * Observable that emits when user logs out.
   * Subscribe to this to perform cleanup on logout.
   */
  public readonly logout$ = this._logoutSubject.asObservable();

  /**
   * Triggers a logout event.
   * Should only be called by LogoutUseCase.
   */
  public triggerLogout(): void {
    this._logoutSubject.next();
  }
}
